module.exports = __webpack_public_path__ + "static/media/bug.416ceb6c.svg";